import {
  HUMAN_ACCOUNT_TYPE_VALUES,
  type HumanAccountType,
} from './index';

export type BrowserAuthorizationInput = {
  realmRoles: readonly string[];
  resourceRoles?: readonly string[];
};

export type BrowserAuthorization = {
  humanAccountTypes: HumanAccountType[];
};

/**
 * Projects only the exact realm Human Account Type. Resource roles remain
 * display metadata and cannot widen product authority.
 *
 * Capabilities are deliberately absent (ADR 0275): they are served per subject
 * by `getProviderCapabilities`, so nothing in the browser derives them from a
 * token claim and there is no second copy to compare against.
 */
export function projectBrowserAuthorization(
  input: BrowserAuthorizationInput,
): BrowserAuthorization {
  const humanAccountTypes = HUMAN_ACCOUNT_TYPE_VALUES.filter((accountType) =>
    input.realmRoles.includes(accountType),
  );

  return {
    humanAccountTypes: humanAccountTypes.length === 1 ? humanAccountTypes : [],
  };
}
